import { CONSTANTS } from '../game.js';

/**
 * スコア送信アイコン用のテクスチャを管理するクラス
 */
export class SubmitIconTexture {
    /**
     * 全ての送信アイコンテクスチャを読み込む
     * @param {Phaser.Scene} scene - テクスチャを読み込むシーン
     * @returns {boolean} テクスチャ読み込みの成否
     */
    static createAll(scene) {
        try {
            // アイコン画像のパス
            const iconBasePath = 'assets/images/icons';
            
            // 送信中アイコンをスプライトシートとして読み込み（4フレーム）
            if (!scene.textures.exists('submit_sending')) {
                scene.load.spritesheet('submit_sending', `${iconBasePath}/submit_sending.png`, {
                    frameWidth: 24, // 各フレームの幅
                    frameHeight: 24 // 各フレームの高さ
                });
            }
            
            // 送信完了アイコンを読み込み
            if (!scene.textures.exists('submit_success')) {
                scene.load.image('submit_success', `${iconBasePath}/submit_success.png`);
            }
            
            // 送信失敗アイコンを読み込み
            if (!scene.textures.exists('submit_failed')) {
                scene.load.image('submit_failed', `${iconBasePath}/submit_failed.png`);
            }
            
            // 画像の読み込みを開始
            scene.load.start();
            
            // 読み込み完了イベントを設定
            scene.load.on('complete', () => {
                console.log('SubmitIconTexture: 全ての送信アイコンテクスチャを読み込みました');
            });
            
            return true;
        } catch (error) {
            console.error('SubmitIconTexture: 送信アイコンテクスチャの読み込み中にエラーが発生しました', error);
            return false;
        }
    }
}